import { Hooks } from 'Components/Hooks';

import {
  Backdrop,
  ViewConnected,
  StatusMessage,
  CallTimer,
  QualityWarning,

  ConfMeters,
  ConfModeLabel,
  ToggleHoldButton,
  ToggleMuteButton,
  ToggleHandRaisedButton,
  ToggleMusicOnHoldButton,
  ToggleDialpadButton,
  SettingsIconButton,
  FinishNameRecordingButton,

  DialpadModal,

  DisconnectButton,

  ViewConnecting,
  QualityMeterModal,
  MediaErrorModal,
  SettingsModal,

  registerDrawLoop,
} from 'WebCall/UIComponents';

import { ConfDebugView } from 'WebCall/DebugComponents';

export default function LinkCallUI({ ctrl }) {
  const hooks = new Hooks();

  const ctx = {
    hooks,
    ctrl,
  };

  const root = (
    <div class="conf-call-ui">
      <Backdrop ctx={ctx} />
      <ConfDebugView ctx={ctx} />
      <ViewConnected ctx={ctx}>
        <FinishNameRecordingButton ctx={ctx} />
        <StatusMessage ctx={ctx} />
        <CallTimer ctx={ctx} />
        <QualityWarning ctx={ctx} />

        <ConfMeters ctx={ctx} />

        <ConfModeLabel ctx={ctx} />

        <div class="btn-panel">
          <div class="btn-toolbar-full">
            <ToggleHoldButton ctx={ctx} />
            <ToggleMuteButton ctx={ctx} />
            <ToggleHandRaisedButton ctx={ctx} />
          </div>

          <div class="btn-toolbar-full">
            <ToggleDialpadButton ctx={ctx} />
            <SettingsIconButton ctx={ctx} />
            <ToggleMusicOnHoldButton ctx={ctx} />
          </div>

          <DialpadModal ctx={ctx} anchored={false} />
        </div>

        <DisconnectButton ctx={ctx} />
      </ViewConnected>

      <ViewConnecting ctx={ctx} />

      <QualityMeterModal ctx={ctx} anchored={false} />
      <MediaErrorModal ctx={ctx} anchored={false} />
      <SettingsModal ctx={ctx} anchored={false} />
    </div>
  );

  registerDrawLoop(ctrl, root);

  ctrl.on('update', () => hooks.run(ctrl));
  hooks.run(ctrl);

  return root;
}
